import { render, staticRenderFns } from "./fillBox.vue?vue&type=template&id=1232901c&scoped=true&"
import script from "./fillBox.vue?vue&type=script&lang=js&"
export * from "./fillBox.vue?vue&type=script&lang=js&"
import style0 from "./fillBox.vue?vue&type=style&index=0&id=1232901c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1232901c",
  null
  
)

export default component.exports